import React from "react";
import { Badge } from "@/components/ui/badge";
import type { SampleStatus } from "./sampleTypes";

export const SAMPLE_STATUS_LABELS: Record<SampleStatus, string> = {
  REQUESTED: "Requested",
  SENT: "Sent",
  FEEDBACK_RECEIVED: "Feedback in",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  CANCELLED: "Cancelled",
};

const VARIANTS: Record<SampleStatus, "default" | "secondary" | "destructive" | "outline" | "success" | "warning" | "blue"> = {
  REQUESTED: "secondary",
  SENT: "blue",
  FEEDBACK_RECEIVED: "warning",
  APPROVED: "success",
  REJECTED: "destructive",
  CANCELLED: "outline",
};

export function SampleStatusBadge({ status, overdue }: { status: SampleStatus; overdue?: boolean }) {
  if (overdue) return <Badge variant="destructive">Feedback overdue</Badge>;
  return <Badge variant={VARIANTS[status] || "outline"}>{SAMPLE_STATUS_LABELS[status] || status}</Badge>;
}
